import theme from "@shared/utils/themeColors";
import React from "react";
import { SidebarActionItem } from "./SidebarActionItem";
import { SidebarGroup } from "./SidebarGroup";
import { SidebarItem } from "./SidebarItem";
import { SidebarItemType, SidebarSectionItem } from "./types";

interface SidebarSectionProps {
	item: SidebarSectionItem;
	onExpand: () => void;
	getBadgeForItem: (itemId: string) => React.ReactNode;
	sidebarExpanded: boolean;
}

export const SidebarSection: React.FC<SidebarSectionProps> = ({
	item,
	onExpand,
	getBadgeForItem,
	sidebarExpanded,
}) => {
	return (
		<li className="mt-4 first:mt-0">
			{item.label && (
				<h3
					className={`text-xs uppercase ${theme.text.muted} font-semibold pl-3 mb-2 truncate transition-all duration-200 ${sidebarExpanded
							? "md:opacity-100 md:max-w-full"
							: "md:opacity-0 md:max-w-0 md:h-0 md:mb-0 md:overflow-hidden md:sidebar-expanded:opacity-100 md:sidebar-expanded:max-w-full md:sidebar-expanded:h-auto md:sidebar-expanded:mb-2"
						} xl:opacity-100 xl:max-w-full xl:h-auto xl:mb-2`}
				>
					{item.label}
				</h3>
			)}
			<ul>
				{item.children.map((child) => {
					if (child.type === SidebarItemType.LINK) {
						return (
							<SidebarItem
								key={child.id}
								item={child}
								badge={getBadgeForItem(child.id)}
							/>
						);
					}
					if (child.type === SidebarItemType.GROUP) {
						return (
							<SidebarGroup key={child.id} item={child} onExpand={onExpand} />
						);
					}
					if (child.type === SidebarItemType.ACTION) {
						return (
							<SidebarActionItem
								key={child.id}
								item={child}
								badge={getBadgeForItem(child.id)}
							/>
						);
					}
					return null;
				})}
			</ul>
		</li>
	);
};
